export default __webpack_public_path__ + "static/media/github.b3e0bb34.svg";